export class RegionDetailsVM{
    modifiedDate: Date;
    region: string;
}